/** Single-weight line icons (1.8px stroke, round caps) per ART-BIBLE section 5.
 *  Herd icon is an antelope/deer head. No elephants anywhere. */
import type { SVGAttributes } from 'preact/compat';

type P = SVGAttributes<SVGSVGElement>;
const base = (p: P) => ({
  viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.8, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, ...p,
});

export const IconReserve = (p: P) => ( // acacia tree
  <svg {...base(p)}>
    <path d="M2.8 10.2C4.6 6.9 8 5 12 5s7.4 1.9 9.2 5.2c-2.6 1.1-5.9 1.7-9.2 1.7s-6.6-.6-9.2-1.7Z" />
    <path d="M12 21v-9.1" />
    <path d="M12 14.5c-1.8-1.2-3.2-3-3.8-5.3" />
    <path d="M12 13c1.6-1 2.8-2.6 3.4-4.6" />
    <path d="M8.5 21h7" />
  </svg>
);
export const IconMap = (p: P) => ( // folded map + pin
  <svg {...base(p)}>
    <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z" />
    <path d="M9 4v14M15 6v14" />
  </svg>
);
export const IconHerd = (p: P) => ( // antelope head, front view
  <svg {...base(p)}>
    <path d="M10.1 10.2C8.8 8.4 7.7 5.9 7.3 2.9" />
    <path d="M8.8 7.4 7.1 6.5M9.4 8.9 7.9 9.4" />
    <path d="M13.9 10.2c1.3-1.8 2.4-4.3 2.8-7.3" />
    <path d="M15.2 7.4l1.7-.9M14.6 8.9l1.5.5" />
    <path d="M9.7 11.6 7 10.1M14.3 11.6l2.7-1.5" />
    <path d="M12 20.8c-2.4 0-3.9-1.9-3.9-4.5 0-2.1.8-3.7 1.7-4.7.5-.6 1.4-1 2.2-1s1.7.4 2.2 1c.9 1 1.7 2.6 1.7 4.7 0 2.6-1.5 4.5-3.9 4.5Z" />
    <circle cx="10.2" cy="14.3" r="0.45" fill="currentColor" stroke="none" />
    <circle cx="13.8" cy="14.3" r="0.45" fill="currentColor" stroke="none" />
    <path d="M12 17.4v.9" />
  </svg>
);
export const IconPark = (p: P) => ( // gazebo / viewing shelter
  <svg {...base(p)}>
    <path d="M4 9 12 4l8 5" />
    <path d="M5.5 9v2M18.5 9v2" />
    <path d="M6 11h12" />
    <path d="M7 11v7M17 11v7M12 11v7" />
    <path d="M4.5 18h15M6 21h12" />
  </svg>
);
export const IconOffice = (p: P) => ( // clipboard
  <svg {...base(p)}>
    <rect x="5.5" y="4.5" width="13" height="16" rx="2" />
    <path d="M9 4.5V3.2h6v1.3" />
    <path d="M9 9.5h6M9 13h6M9 16.5h4" />
  </svg>
);
export const IconGear = (p: P) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="6.6" />
    <circle cx="12" cy="12" r="2.9" />
    <path d="M12 3v2.4M12 18.6V21M3 12h2.4M18.6 12H21M5.6 5.6l1.7 1.7M16.7 16.7l1.7 1.7M18.4 5.6l-1.7 1.7M7.3 16.7l-1.7 1.7" />
  </svg>
);
export const IconCoin = (p: P) => (
  <svg {...base(p)}>
    <ellipse cx="12" cy="7" rx="7" ry="3.4" />
    <path d="M5 7v5c0 1.9 3.1 3.4 7 3.4s7-1.5 7-3.4V7" />
    <path d="M5 12v5c0 1.9 3.1 3.4 7 3.4s7-1.5 7-3.4v-5" />
  </svg>
);
export const IconPaw = (p: P) => (
  <svg {...base(p)}>
    <circle cx="7.2" cy="8.6" r="1.7" /><circle cx="12" cy="6.8" r="1.7" /><circle cx="16.8" cy="8.6" r="1.7" />
    <path d="M12 11.5c-3 0-5.4 2.3-5.4 5 0 1.6 1.3 2.8 2.9 2.8 1 0 1.7-.5 2.5-.5s1.5.5 2.5.5c1.6 0 2.9-1.2 2.9-2.8 0-2.7-2.4-5-5.4-5Z" />
  </svg>
);
export const IconLeaf = (p: P) => (
  <svg {...base(p)}>
    <path d="M5 19C5 10 11 5 19.5 4.5 19 13 14 19 5 19Z" />
    <path d="M5 19c3-5 7-8.5 11-10.5" />
  </svg>
);
export const IconDna = (p: P) => (
  <svg {...base(p)}>
    <path d="M7 3c0 4 10 6 10 10s-10 6-10 8M17 3c0 4-10 6-10 10s10 6 10 8" />
    <path d="M8.2 6.5h7.6M8.2 17.5h7.6M9.5 12h5" />
  </svg>
);
export const IconRings = (p: P) => (
  <svg {...base(p)}>
    <circle cx="9.3" cy="12" r="5.3" /><circle cx="14.7" cy="12" r="5.3" />
  </svg>
);
export const IconChevron = (p: P) => (
  <svg {...base(p)}><path d="m9 5 6 7-6 7" /></svg>
);
export const IconClose = (p: P) => (
  <svg {...base(p)}><path d="M6 6l12 12M18 6 6 18" /></svg>
);
export const IconCamera = (p: P) => (
  <svg {...base(p)}>
    <path d="M4 8h3.2l1.6-2.4h6.4L16.8 8H20v11H4V8Z" />
    <circle cx="12" cy="13.2" r="3.2" />
  </svg>
);
export const IconWarn = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 3.5 21 19.5H3L12 3.5Z" />
    <path d="M12 10v4.4" /><circle cx="12" cy="17" r="0.5" fill="currentColor" />
  </svg>
);
export const IconHat = (p: P) => ( // ranger
  <svg {...base(p)}>
    <path d="M8.5 13c-1-3.2-1.2-6 .6-8 1.2 1.2 2.4 1.6 2.9 1.6s1.7-.4 2.9-1.6c1.8 2 1.6 4.8.6 8" />
    <path d="M3.5 13.5c2-1 5.4-1.5 8.5-1.5s6.5.5 8.5 1.5c-1.6 1.3-5 2-8.5 2s-6.9-.7-8.5-2Z" />
    <path d="M9.5 17.5c.8 1.4 1.6 2.3 2.5 2.3s1.7-.9 2.5-2.3" />
  </svg>
);
export const IconSteth = (p: P) => ( // veterinarian
  <svg {...base(p)}>
    <path d="M7 3.5v5a4 4 0 0 0 8 0v-5" />
    <path d="M6 3.5h2M14 3.5h2" />
    <path d="M11 12.5v3.2a3.8 3.8 0 0 0 7.6 0v-2" />
    <circle cx="18.6" cy="11" r="2" />
  </svg>
);
export const IconBinocs = (p: P) => ( // scout
  <svg {...base(p)}>
    <path d="M8 4.5h2.6v6H8zM13.4 4.5H16v6h-2.6z" transform="translate(0 1)" />
    <circle cx="8.6" cy="15.5" r="3.6" /><circle cx="15.4" cy="15.5" r="3.6" />
    <path d="M10.6 5.5h2.8" transform="translate(0 1)" />
  </svg>
);
export const IconFinance = (p: P) => (
  <svg {...base(p)}>
    <path d="M4 20V10M10 20V4M16 20v-8M22 20H2" transform="translate(-1 0)" />
    <path d="M20 20v-13" transform="translate(-1 0)" />
  </svg>
);
export const IconDoc = (p: P) => (
  <svg {...base(p)}>
    <path d="M6 3h8l4 4v14H6V3Z" /><path d="M14 3v4h4" /><path d="M9 12h6M9 16h6" />
  </svg>
);
export const IconFlask = (p: P) => (
  <svg {...base(p)}>
    <path d="M10 3v6L4.5 19.5h15L14 9V3" /><path d="M8.5 3h7" /><path d="M7.5 14.5h9" />
  </svg>
);
export const IconHandshake = (p: P) => (
  <svg {...base(p)}>
    <path d="m3 7 4-2 5 2 5-2 4 2v9l-4 2-5-2-5 2-4-2V7Z" transform="scale(0.9) translate(1.3 2)" />
  </svg>
);
export const IconTag = (p: P) => (
  <svg {...base(p)}>
    <path d="M4 4h7l9 9-7 7-9-9V4Z" /><circle cx="8.5" cy="8.5" r="1.4" />
  </svg>
);
export const IconLand = (p: P) => (
  <svg {...base(p)}>
    <path d="M3 18c3-1.5 5-4 9-4s6 2.5 9 4" /><path d="M3 21h18" />
    <path d="M12 4v6M9.5 6.5 12 4l2.5 2.5" />
  </svg>
);

export const IconFence = (p: P) => (
  <svg {...base(p)}>
    <path d="M4 7 6.5 5 9 7v13H4V7ZM15 7l2.5-2L20 7v13h-5V7Z" />
    <path d="M9 10h6M9 16h6" />
  </svg>
);
export const IconWater = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 3.5C15 8 17.5 11 17.5 14.5a5.5 5.5 0 1 1-11 0C6.5 11 9 8 12 3.5Z" />
    <path d="M9.5 14.5a2.5 2.5 0 0 0 2.5 2.5" />
  </svg>
);
export const IconBrush = (p: P) => (
  <svg {...base(p)}>
    <path d="M14.5 3.5 20.5 9.5 10 20l-6 1 1-6 9.5-11.5Z" transform="translate(-0.5 0)" />
    <path d="m13 6 5 5" />
  </svg>
);
